import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m18.985 8.085-1.56-1.562a1.49 1.49 0 0 0-1.748-.235 1.458 1.458 0 0 1-1.965-1.965 1.49 1.49 0 0 0-.236-1.748l-.572-1.561a1.46 1.46 0 0 0-2.062 0L1.014 9.853a1.46 1.46 0 0 0 0 2.062l1.56 1.562a1.49 1.49 0 0 0 1.748.235 1.459 1.459 0 0 1 1.965 1.965 1.49 1.49 0 0 0 .236 1.748l1.562 1.56a1.46 1.46 0 0 0 2.062 0l8.838-8.838a1.46 1.46 0 0 0 0-2.062m-11.342 2.16a.834.834 0 1 1 0-1.669.834.834 0 0 1 0 1.668Zm2.982 2.255a.625.625 0 0 1-1.25 0v-5a.625.625 0 0 1 1.25 0zm1.732-1.077a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667" }, null, -1)
  ])))
}
export default { render: render }